import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useSelector } from 'react-redux';
import NotificationDropdown from '../components/NotificationDropdown';

const PATH_LABELS = {
    '/lims/dashboard': 'Dashboard',
    '/lims/clients': 'Clients',
    '/lims/addClients': 'Add Client',
    '/lims/addEnquiry': 'Add Enquiry',
    '/lims/enquiry': 'Enquiries',
    '/lims/orders': 'Orders',
    '/lims/addOrders': 'New Order',
    '/lims/Sample': 'Samples',
    '/lims/addSample': 'New Sample',
    '/lims/bulkAddSample': 'Bulk Add Samples',
    '/lims/addFssaiSample': 'New FSSAI Sample',
    '/lims/SampleLt': 'Samples (LT)',
    '/lims/invoice': 'Invoice',
    '/apps/settings/suppliers': 'Suppliers',
    '/apps/settings/addSuppliers': 'New Supplier',
    '/apps/settings/supplierEvaluation': 'Supplier Evaluation',
    '/apps/settings/supplierRating': 'Supplier Rating',
    '/apps/settings/inventory': 'Inventory',
    '/apps/settings/inventoryUsageLog': 'Inventory Usage Log',
    '/apps/settings/indent': 'Indent',
    '/apps/settings/labdepartments': 'Lab Departments',
    '/apps/settings/labcontact': 'Lab Contacts',
    '/apps/settings/analysisCategory': 'Groups',
    '/apps/settings/analysisService': 'Analysis Parameters',
    '/apps/settings/units': 'Units',
    '/apps/settings/testmethods': 'Test Methods',
    '/apps/settings/users': 'Users',
    '/apps/settings/profile': 'My Profile',
    '/account/change-password': 'Change Password',
};

// Each entry is an array of CTA buttons for that page.
const CTA_MAP = {
    '/lims/clients': [
        { label: '+ New client', path: '/lims/addClients' },
    ],
    '/lims/enquiry': [
        { label: '+ New enquiry', path: '/lims/addEnquiry' },
    ],
    '/lims/Sample': [
        { label: '+ New sample', path: '/lims/addSample' },
        { label: '+ Bulk sample', path: '/lims/bulkAddSample' },
        { label: '+ FSSAI sample', path: '/lims/addSample', state: { fssaiSample: 'yes' } },
    ],
    '/apps/settings/suppliers': [
        { label: '+ New supplier', path: '/apps/settings/addSuppliers' },
    ],
    '/apps/settings/inventory': [
        { label: '+ New item', path: '/apps/settings/addInventory' },
    ],
    '/apps/settings/indent': [
        { label: '+ New indent', path: '/apps/settings/addIndent' },
    ],
    '/apps/settings/users': [
        { label: '+ New user', path: '/apps/settings/addUsers' },
    ],
    '/apps/settings/labdepartments': [
        { label: '+ New department', path: '/apps/settings/addLabDepartment' },
    ],
    '/apps/settings/analysisCategory': [
        { label: '+ New group', path: '/apps/settings/addAnalysisCategory' },
    ],
    '/apps/settings/analysisService': [
        { label: '+ New parameter', path: '/apps/settings/addAnalysisService' },
    ],
    '/apps/settings/labcontact': [
        { label: '+ New contact', path: '/apps/settings/addLabContact' },
    ],
    '/apps/settings/supplierEvaluation': [
        { label: '+ New evaluation', path: '/apps/settings/addSupplierEvaluation' },
    ],
    '/apps/settings/supplierRating': [
        { label: '+ New rating', path: '/apps/settings/addSupplierRating' },
    ],
};

function AppTopbar({ onMenuToggle }) {
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;

    const { user } = useSelector((state) => ({
        user: state.Auth.user,
    }));

    const pageLabel = PATH_LABELS[path] || formatPathLabel(path);
    let ctas = CTA_MAP[path] || [];

    if (path === '/lims/Sample') {
        const hasAccess = user?.role === 'admin' || user?.role === 'lab assistant';
        if (!hasAccess) {
            ctas = ctas.filter(
                (cta) => cta.label !== '+ New sample' && cta.label !== '+ FSSAI sample' && cta.label !== '+ Bulk sample'
            );
        }
    }

    function formatPathLabel(p) {
        const segment = p.split('/').filter(Boolean).pop() || '';
        return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
    }

    const handleCta = (cta) => {
        navigate(cta.path, cta.state ? { state: cta.state } : undefined);
    };

    return (
        <header className="lims-topnav">
            <div className="lims-topnav-left">
                {/* Hamburger — visible on mobile only */}
                <button className="lims-tn-hamburger" onClick={onMenuToggle} type="button" aria-label="Open menu">
                    <Menu size={16} />
                </button>

                <span className="lims-breadcrumb">Optima LIMS</span>
                <span className="lims-breadcrumb-sep">/</span>
                <span className="lims-breadcrumb-current">{pageLabel}</span>
            </div>

            <div className="lims-topnav-right">
                <NotificationDropdown isAppTopbar={true} />

                {ctas.map((cta, i) => (
                    <button key={i} className="lims-tn-btn-primary" onClick={() => handleCta(cta)} type="button">
                        {cta.label}
                    </button>
                ))}
            </div>
        </header>
    );
}

export default AppTopbar;
